import { ReactNode, useEffect, useState, useRef, FormEvent } from 'react'
import { Background, Container } from './styles'

type ModalProps = {
  children: ReactNode
  isOpened: boolean
  onRequestClose: () => void
  className?: string
  style?: {
    width: string
  }
  overlayColor?: string
}

export function Modal({ children, isOpened, onRequestClose, className, style, overlayColor }: ModalProps) {
  const backgroundRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(isOpened)
  }, [isOpened])

  function handleBackgroundClick(event: FormEvent) {
    if (event.target === backgroundRef.current) {
      onRequestClose()
    }
  }

  return isOpen ? (
    <Background overlayColor={overlayColor} onClick={(event) => handleBackgroundClick(event)} ref={backgroundRef}>
      <Container style={style} className={className}>
        {children}
      </Container>
    </Background>
  ) : null
}
